import React, { Component } from 'react'
import Cookies from 'universal-cookie'
import { API_USER_LOGIN } from '../../api'
import './login.css'

const cookies = new Cookies()

export default class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
      username: '',
      password: '',
      eye: false,
    }
  }

  componentDidMount() {
    this.refs.loginUser.focus()
  }

  onSubmit = (e) => {
    e.preventDefault()
    const setParams = {
      username: this.state.username,
      password: this.state.password,
    }
    API_USER_LOGIN(setParams)
      .then((response) => {
        cookies.set('tokenSASSafecash', response.data.accessToken)
        cookies.set('usernameSASSafecash', response.data.fullname)
        window.location.href = '/dashboard'
      })
      .catch((err) => {
        if (err.response) {
          this.setState({
            errorMsg: err.response.data.message,
          })
        } else {
          this.setState({
            errorMsg: 'Network Error',
          })
        }
      })
  }

  changeUsername = e => this.setState({ username: e.target.value })

  changePassword = e => this.setState({ password: e.target.value })

  toggleViewPassword = () => {
    const password = this.refs.loginPassword
    if (password.type === 'password') {
      password.type = 'text'
    } else {
      password.type = 'password'
    }
    this.setState({ eye: !this.state.eye })
  }

  render() {
    const { errorMsg, username, password } = this.state

    let msgError = ''
    if (errorMsg !== '') {
      msgError = <div className="login__message">{errorMsg}</div>
    }

    return (
      <div className="login">
        <div className="login__inner">
          <h2 className="login__title">LOGIN</h2>
          <div className="login__text">Please Enter Your Information</div>
          <form className="login__form" onSubmit={this.onSubmit}>
            <input
              type="text"
              ref="loginUser"
              name="username"
              placeholder="Username or email"
              value={username}
              onChange={this.changeUsername}
            />
            <div className={this.state.eye ? 'password-with-icon on' : 'password-with-icon'}>
              <input
                type="password"
                name="password"
                ref="loginPassword"
                placeholder="Password"
                value={password}
                onChange={this.changePassword}
              />
              <img src="https://cdn0.iconfinder.com/data/icons/feather/96/eye-16.png" alt="View" title="View" onClick={this.toggleViewPassword} />
            </div>
            <button type="submit" className="login__button">LOGIN</button>
            {msgError}
          </form>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/login/index.js